"use strict";

import dispatcher from "./../dispatcher";
import {Singleton} from "vwa/flux";

const autoZoomStore = new Singleton();
export default autoZoomStore;

window.autoZoomStore = autoZoomStore;

autoZoomStore.set(false);

dispatcher.on('toggleAutoZoom', () => {
	autoZoomStore.set(!autoZoomStore.get())
});

dispatcher.on('turnOffAutoZoom', () => {
	autoZoomStore.set(false)
});

dispatcher.on('logout', () => {
	autoZoomStore.set(false)
});


// WEBPACK FOOTER //
// ./src/store/autoZoom.js